import { Swiper } from 'swiper';
import { Mousewheel, Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import './index.scss';
/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable no-new */

(function () {
  /**
  * initializeBlock
  *
  * Adds custom JavaScript to the block HTML.
  *

  * @since   1.0.0
  *
  * @param   object $block The block jQuery element.
  * @param   object attributes The block attributes (only available when editing).
  * @return  void
  */
  const blockClass = `wp-block-imado-testimonials`;
  const blockType = `wp-block-imado-testimonials`;

  function initBlock(block) {
    if (block.querySelectorAll('.swiper-slide').length > 1) {
      new Swiper(block.querySelector('.swiper'), {
        modules: [Mousewheel, Autoplay, Navigation],
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: false,
        speed: 1500,
        keyboard: true,
        loop: true,
        mousewheel: {
          releaseOnEdges: true,
          forceToAxis: true,
        },
        breakpoints: {

          600: {
            slidesPerView: 1.4
          },

          782: {
            slidesPerView: 2
          },
        },
      });
    }

  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`.${blockClass}`).forEach((block) => {
      initBlock(block);
    });
  });

  const initializeBlock = function ($block) {
    const block = $block[0].querySelector(`.${blockClass}`);
    if (block) {
      initBlock(block);
    }
  };

  if (window.acf) {
    window.acf.addAction(
      `render_block_preview/type=${blockType}`,
      initializeBlock
    );
  }
})();